<template>
  <ModalFade
    class="action-sheet"
    @close="onClickOutside"
  >
    <div
      ref="root"
      class="action-sheet__container"
      :style="transform"
    >
      <div
        class="action-sheet__header"
        @mousedown="activateDrag"
        @mouseup="disableDrag"
        @mouseleave="disableDrag"
        @mousemove="onPointermove"
        @touchstart="activateDrag"
        @touchend="disableDrag"
        @touchmove="onPointermove"
      />
      <div class="action-sheet__body">
        <slot />
      </div>
    </div>
  </ModalFade>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ModalFade from '~/components/ModalFade.vue';
  export default defineNuxtComponent({
    name: 'ActionSheet',
    components: {
      ModalFade,
    },

    props: {
      closeClickOutside: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
    },

    data(): any {
      return {
        transform: '',
        drag: false,
        y: 0,
        startPosY: null,
      };
    },

    methods: {
      onClickOutside(): void {
        if (this.closeClickOutside) {
          this.$emit('close');
        }
      },

      activateDrag(e: any): void {
        this.drag = true;
        this.startPosY = e.clientY || e.changedTouches[0].clientY;
      },

      disableDrag(): void {
        const actionSheet = this.$refs.root as HTMLElement;
        this.drag = false;
        this.startPosY = null;
        if (this.y <= actionSheet?.offsetHeight / 2) {
          this.transform = 'transition: .3s transform linear; transform: translateY(0);';
        } else {
          this.$emit('close');
          this.transform = 'transition: .3s transform linear; transform: translateY(100%);';
        }
      },

      onPointermove(e: any): void {
        if (this.drag && this.startPosY !== null) {
          // ts ругается, что startPosY может быть нулом, хотя проверка на это есть выше
          // @ts-expect-error startPosY is narrowed above but TS can't infer
          this.y = -(this.startPosY - (e.clientY || e.changedTouches[0].clientY));
          if (this.y < 0) {
            return;
          }
          this.transform = `transition: none; transform: translateY(${this.y}px)`;
        }
      },
    },
  });
</script>

<style lang="scss" scoped>
  @keyframes action-sheet {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }

  .action-sheet {
    display: flex;
    align-items: center;
    align-content: end;

    &__container {
      width: 100%;
      background: #ffffff;
      border-radius: 32px 32px 0 0;
      position: relative;
      box-shadow: 0 0 0 4px black;

      animation-name: action-sheet;
      animation-duration: 0.3s;
      animation-timing-function: linear;
      animation-delay: 0.3s;
    }

    &__header {
      height: 48px;
      width: 100%;
      &::before {
        position: absolute;
        content: '';
        background: $stroke-color--1;
        width: 36px;
        height: 4px;
        border-radius: 2px;
        top: 22px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
  }
</style>
